const hasSdkError = response => {
  const error = response.error || response.errors;
  if (error) {
    return error && error.reason;
  } else if (response.reason || (response.reason || {}).reason) {
    return response.reason;
  }
  return false;
};

export default hasSdkError;
